/* eslint-disable react/no-unescaped-entities */
"use client";

import React, { useState, useRef, useEffect } from "react";

import Heading from "@/components/heading/heading";
import Button from "@/components/button/Button";

import Arrow from "@/public/svg/arrow-right.svg";
import Buttonwhatsapp from "@/public/svg/common/social-icons/whatsapp.svg";
import RightIcon from "@/public/svg/line-arrow-right.svg";

import Image from "next/image";

import "@/sections/common/tariff/tariff.scss";
import Head from "next/head";

const Tariff = () => {
    const [showSecondContainer, setShowSecondContainer] = useState(false);
    const secondContainerRef = useRef<HTMLDivElement | null>(null);

    const handleViewMore = () => {
        setShowSecondContainer(true);
    };

    const handleViewLess = () => {
        setShowSecondContainer(false);

        const familyPackagesElement = document.getElementById("tariffsection");
        if (familyPackagesElement) {
            familyPackagesElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        if (secondContainerRef.current) {
            if (showSecondContainer) {
                // Set max-height to the actual height of the content for smooth transition
                const contentHeight = secondContainerRef.current.scrollHeight;
                secondContainerRef.current.style.maxHeight = `${contentHeight}px`;
            } else {
                secondContainerRef.current.style.maxHeight = "0";
            }
        }
    }, [showSecondContainer]);

    return (
        <section className="tariff-section pt-6" id="tariffsection">
            <div className="container px-4 mx-auto">
                <div className="tariff-wrapper flex flex-col gap-6 p-3 md:p-6">
                    <div className="tariff-head pb-3">
                        <Heading as="h2">
                            Vietnam Honeymoon Package - For Everyone
                        </Heading>
                    </div>
                    <div className="tariff-body-footer flex flex-col gap-6">
                        <div className="tariff-body flex flex-col gap-4 px-3 md:px-6">
                            <div className="flex flex-col gap-1">
                                <p className="lead">
                                    Are you planning a honeymoon? If you are
                                    looking for a peaceful trip away from crowds
                                    and the hustle and bustle of the city,
                                    Vietnam could be your destination. Gift the
                                    Vietnam Honeymoon Package from Dimaak Tours
                                    and craft the best memory for your better
                                    half.
                                    {!showSecondContainer && (
                                        <span
                                            className="font-medium view-more ml-4 cursor-pointer"
                                            onClick={handleViewMore}
                                        >
                                            View More
                                        </span>
                                    )}
                                </p>
                            </div>
                            <div
                                id="second-container"
                                ref={secondContainerRef}
                                className={`transition-all duration-500 overflow-hidden ${
                                    showSecondContainer
                                        ? "max-h-full opacity-100"
                                        : "max-h-0 opacity-0"
                                }`}
                            >
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Vietnam’s Beauty: The Perfect Honeymoon
                                        Destination
                                    </Heading>
                                    <p className="lead">
                                        Vietnam is a country that balances
                                        traditionality and modernity. It is a
                                        country where you can find the perfect
                                        divisional balance between villages and
                                        cities. Whether you want peace or
                                        liveliness, it has everything to satisfy
                                        you. So, what are you waiting for?
                                        Contact us now and plan your honeymoon
                                        trip to Vietnam.
                                    </p>
                                    <p className="lead">
                                        <strong>
                                            Hanoi, Danang, Hoi An, Halong Bay,
                                            Ho Chi Minh, and Phu Quoc{" "}
                                        </strong>{" "}
                                        are the ideal places to visit in Vietnam
                                        for your honeymoon. So, let's learn
                                        about each of Vietnam's honeymoon places
                                        and its sightseeing to see what each
                                        city has to offer.
                                    </p>

                                    <p className="lead">
                                        Vietnam is a destination that rises
                                        above simple travel, a memory that
                                        lingers long after one leaves. From the
                                        beautiful natural landscapes to the rich
                                        embroidery of culture and history,
                                        Vietnam offers a brief look into a land
                                        where the past illuminates the present,
                                        and the future is painted with dynamic
                                        shades of possibility.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Hanoi & Halong Bay
                                    </Heading>
                                    <p className="lead">
                                        Hanoi is the capital city of Vietnam. It
                                        is the treasure trove of Vietnam, as it
                                        has safely kept thousands of years of
                                        culture and traditions alive. It also
                                        evolves each day and is thus a modern
                                        metropolis in today’s date. Let's check
                                        out some of the sightseeing in Hanoi-
                                    </p>
                                    <ul>
                                        <li>Hanoi Old Quarter</li>
                                        <li>Hoan Kiem Lake</li>
                                        <li>Temple of Literature</li>
                                        <li>Ho Chi Minh Mausoleum</li>
                                        <li>Hoa Lo Prison</li>
                                        <li>Vietnam Museum of Ethnology</li>
                                        <li>Ninh Binh</li>
                                    </ul>
                                    <p className="lead">
                                        [Note: Honeymoon couples can take a
                                        full-day Hanoi city tour and explore the
                                        above-mentioned places. They can also
                                        take a full-day Ninh Binh Tour.]
                                    </p>
                                    <p className="lead">
                                        Halong Bay is 117 km from Hanoi. Hanoi
                                        and Halong Bay are usually considered
                                        when traveling to northern Vietnam. The
                                        main attraction is surrounded by
                                        towering limestone pillars, which can be
                                        explored by kayaking. Below is a list of
                                        activities and sightseeing that you will
                                        find in Halong Bay-
                                    </p>
                                    <Heading as="h4">Activities:</Heading>
                                    <ul>
                                        <li>Kayaking or paddleboarding</li>
                                        <li>Scuba diving or snorkeling</li>
                                        <li>Squid fishing at night</li>
                                    </ul>
                                    <Heading as="h4">Sightseeings:</Heading>
                                    <ul>
                                        <li>Sung Sot Cave (Surprise Cave)</li>
                                        <li>
                                            Thien Cung Cave (Palace of Heaven
                                            Cave)
                                        </li>
                                        <li>Titop Island</li>
                                        <li>Vung Vieng Fishing Village</li>
                                        <li>Bai Tu Long Bay</li>
                                        <li>Lan Ha Bay</li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">Danang & Hoi-An:</Heading>
                                    <p className="lead">
                                        These are popular destinations located
                                        30 km away in central Vietnam. Danang is
                                        a modern city with a beautiful
                                        beachfront view, world-class
                                        restaurants, and exciting nightlife. On
                                        the other hand, Hoi An is a UNESCO World
                                        Heritage Site and is famous for its
                                        well-preserved Old Town.
                                    </p>

                                    <Heading as="h4">
                                        Danang Sightseeing Places
                                    </Heading>
                                    <ul>
                                        <li>The Marble Mountains</li>
                                        <li>My Khe Beach</li>
                                        <li>Lady Buddha Statue</li>
                                        <li>Ba Na Hills</li>
                                        <li>Dragon Bridge</li>
                                        <li>Han Market</li>
                                    </ul>
                                    <Heading as="h4">
                                        Hoi An Sightseeing Places
                                    </Heading>
                                    <ul>
                                        <li>Japanese Covered Bridge</li>
                                        <li>Hoi An Ancient Town</li>
                                        <li>Tan Ky Old House</li>
                                        <li>Phuc Kien Assembly Hall</li>
                                        <li>Thu Bon River</li>
                                        <li>Cham Island</li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">Ho Chi Minh</Heading>
                                    <p className="lead">
                                        This city, formerly known as Saigon, is
                                        the largest city in Vietnam and is named
                                        after the Vietnamese communist
                                        revolutionary, politician, and
                                        nationalist Ho Chi Minh. This city has a
                                        traditional charm and a modern vibe,
                                        making it a must-visit destination in
                                        Vietnam.
                                    </p>

                                    <Heading as="h4">
                                        Sightseeing places in Ho Chi Minh:
                                    </Heading>

                                    <ul>
                                        <li>War Remnants Museum</li>
                                        <li>Cu Chi Tunnels</li>
                                        <li>Independence Palace</li>
                                        <li>Notre Dame Cathedral</li>
                                        <li>Central Post Office</li>
                                        <li>Ben Thanh Market</li>
                                        <li>Thien Hau Pagoda</li>
                                        <li>
                                            Golden Dragon Water Puppet Theatre
                                        </li>
                                        <li>Ao Dai Show</li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">Phu Quoc</Heading>
                                    <p className="lead">
                                        Phu Quoc is the largest island situated
                                        in Vietnam. It is popular for its
                                        beaches, rainforests, and lively
                                        nightlife. Phu Quoc is a popular tourist
                                        destination and home to several resorts
                                        and hotels.
                                    </p>
                                    <p className="lead">
                                        Phu Quoc has some of the most beautiful
                                        beaches in Vietnam, such as Bai Sao
                                        Beach, Bai Dai Beach, and Khem Beach.
                                    </p>
                                    <Heading as="h4">
                                        Sightseeing in Phu Quoc
                                    </Heading>
                                    <ul>
                                        <li>Phu Quoc National Park</li>
                                        <li>Ho Quoc Pagoda</li>
                                        <li>Dinh Cau Night Market</li>
                                        <li>Coi Nguon Museum</li>
                                        <li>Phu Quoc Prison</li>
                                        <li>Sim Wine Factory</li>
                                        <li>Pepper Farms</li>
                                    </ul>
                                </div>
                                
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Average Cost of Vietnam Honeymoon
                                        Package
                                    </Heading>
                                    <p className="lead">
                                        Vietnam is a country with a low cost of
                                        living. When planning a honeymoon trip
                                        to Vietnam, it is important to check the
                                        average cost. The average cost of a
                                        honeymoon package in Vietnam varies
                                        depending on various factors, such as
                                        flights, accommodation, sightseeing,
                                        travel season, activities,
                                        transportation, food, etc.
                                    </p>
                                    <p className="lead">
                                        If you are planning your honeymoon in
                                        Vietnam, Dimaak Tours’ Vietnam package
                                        cost from India for honeymoon couples
                                        starts at Rs.39,599 (excluding flights)
                                        and exceeds depending on travel style
                                        and preferences. Our packages vary but
                                        typically include accommodation,
                                        transportation, and sightseeing
                                        activities. The visa cost is exclusive
                                        to the Vietnam honeymoon package.
                                    </p>
                                    <p className="lead">
                                        The factors that affect the Vietnam
                                        Honeymoon Package for couples,
                                    </p>

                                    <p className="lead">
                                        <strong>Accommodation: </strong> Vietnam
                                        offers all kinds of accommodation for
                                        honeymoon couples, from luxurious to
                                        budget-friendly. We have a list of good
                                        accommodation options, and you can pick
                                        your desired stay.
                                    </p>
                                    <p className="lead">
                                        <strong>
                                            Sightseeing Activities:{" "}
                                        </strong>{" "}
                                        We offer customizable sightseeing
                                        activities within the packages to suit
                                        your preferences and budget.
                                    </p>
                                    <p className="lead">
                                        <strong>Transportation: </strong>{" "}
                                        Getting around the city is challenging,
                                        so leave it up to us. We take care of
                                        the airport and sightseeing transfer and
                                        ensure your travel is safe and smooth
                                    </p>
                                    <p className="lead">
                                        <strong>Travel Season: </strong>{" "}
                                        April-May and September-October is the
                                        peak travel season in Vietnam. So, the
                                        average cost may vary, but again, the
                                        starting cost for a honeymoon couple in
                                        Vietnam is less with Dimaak Tours.
                                    </p>
                                    <Heading as="h4">
                                        Average Cost of Vietnam Honeymoon
                                        Package
                                    </Heading>
                                    <ul>
                                        <li>
                                            If you are looking for a
                                            budget-friendly Honeymoon trip to
                                            Vietnam, avoid the peak season and
                                            its crowd.
                                        </li>
                                        <li>
                                            3 Star Hotels, Guest houses and
                                            homestays are usually reasonable.
                                        </li>
                                        <li>
                                            Flights are usually reasonable on
                                            offseasons, Tuesdays and Thursdays.
                                            [Note: Weekends tend to be more
                                            expensive]
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        How to Reach Vietnam from India
                                    </Heading>
                                    <p className="lead">
                                        If you are wondering how to reach
                                        Vietnam from India, we are here to help
                                        you.
                                    </p>
                                    <Heading as="h4">Flights:</Heading>
                                    <p className="lead">
                                        Landing at Hanoi or Ho Chi Minh City is
                                        the best option for traveling from
                                        India. Vietnamese Airlines and Indian
                                        Airlines offer direct flights to
                                        Vietnam.
                                    </p>
                                    <p className="lead">
                                        To reach Vietnam, you can fly with
                                        Vietjet Air and Vietnam Airlines, the
                                        Indian airline Indigo, or other airlines
                                        such as Singapore Airlines, Air Asia,
                                        and Thai Airways.
                                    </p>

                                    <p className="lead">
                                        You can get direct flights from major
                                        Indian cities like Delhi, Mumbai,
                                        Ahmedabad, and Kolkata.
                                    </p>
                                    <p className="lead">
                                        On average, the flight charges one way
                                        per person, starting from INR 14,000 and
                                        exceeding INR 40,000 for a round trip.
                                    </p>

                                    <Heading as="h4">Train:</Heading>
                                    <p className="lead">
                                        If you have time and want an adventurous
                                        option, you should travel by train.
                                        Though it is time-consuming, you can
                                        enjoy the South Asian country ride as it
                                        goes via China and Myanmar.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Vietnam Visa Requirements for Indian
                                        Citizens
                                    </Heading>
                                    <p className="lead">
                                        Honeymoon Couples from India require a
                                        visa to visit Vietnam. The country has
                                        two types of visas available.
                                    </p>
                                    <Heading as="h4">On-Arrival Visa:</Heading>
                                    <p className="lead">
                                        For an on-arrival visa, you need an
                                        approval letter before leaving India.
                                    </p>
                                    <p className="lead">
                                        The approval letter fee is $10.
                                    </p>

                                    <p className="lead">
                                        When you reach Vietnam, you must show
                                        your approval letter to get your
                                        on-arrival visa, which costs $25.
                                    </p>

                                    <Heading as="h4">E-Visa:</Heading>
                                    <p className="lead">
                                        You can get the e-Visa online before
                                        going. It costs around $35,
                                        approximately INR 3500. It is valid for
                                        up to 90 days and allows multiple
                                        entries.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Accommodation in Vietnam for Honeymoon
                                        Couples
                                    </Heading>

                                    <p className="lead">
                                        Vietnam offers all types of
                                        accommodation, from premium five-star
                                        stays to budget-friendly stays. Now, you
                                        can plan and book your luxury Vietnam
                                        honeymoon stay.
                                    </p>

                                    <p className="lead">
                                        Listed below are a few of the best
                                        places for couples to stay in Vietnam,
                                        so why wait? Go check it out.
                                    </p>
                                    <div className="sm:rounded-lg">
                                        <table className="w-full text-sm text-center rtl:text-right bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <thead className="text-lg text-gray-700  bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        className="px-5 py-2 text-center"
                                                    >
                                                        Places
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        className="px-6 py-3"
                                                    >
                                                        5- Star
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        className="px-6 py-3"
                                                    >
                                                        4- Star
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        className="px-6 py-3"
                                                    >
                                                        3-Star
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                    <td className="px-6 py-4 text-left">
                                                        <strong>Hanoi</strong>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.hyatt.com/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Hyatt
                                                                        Regency
                                                                        West
                                                                        Hanoi
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="http://www.grandplazahanoi.com/kor/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Hanoi
                                                                        Grand
                                                                        Plaza
                                                                        Hotel
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.soleilboutiquehotel.com/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Soleil
                                                                        Boutique
                                                                        Hotel
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://aurorahotels.vn/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Aurora
                                                                        Premium
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://operahousesuites.book.rentl.io/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Opera
                                                                        House
                                                                        Suites
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.hanoimayflowerhotel.com/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Mayflower
                                                                        Hotel
                                                                        Hanoi
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                    <td className="px-6 py-4 text-left">
                                                        <strong>
                                                            Halong Bay
                                                        </strong>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.wyndhamhalong.com/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Wyndham
                                                                        Legend
                                                                        Halong
                                                                        Hotel
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://vinpearl.com/vi/hotels/vinpearl-resort-spa-phu-quoc"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Vinpearl
                                                                        Resort &
                                                                        Spa Phu
                                                                        Quoc
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.paradisevietnam.com/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Paradise
                                                                        Suites
                                                                        Halong
                                                                        Hotel
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                Ha Long Paradise
                                                                Hotel
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="http://halong-boutique.halongtophotels.com/en/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Halong
                                                                        Boutique
                                                                        Hotel
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="http://halonglavenderhotel.com"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Halong
                                                                        Lavender
                                                                        Hotel
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                    <td className="px-6 py-4 text-left">
                                                        <strong>
                                                            Danang & Hoi- An
                                                        </strong>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.hilton.com/en/hotels/daddvhi-hilton-da-nang/?WT.mc_id=zLADA0VN1HI2PSH3GGL4INTBPP5dkt6DADDVHI7en_&epid!_&ebuy!&&&&&gad_source=1&gclid=Cj0KCQjwztOwBhD7ARIsAPDKnkCdjJAYTWxBKadHxLffrscnvN1O2kd1hvJ-5XGaF3yQx-plmUocmY0aAhDIEALw_wcB&gclsrc=aw.ds"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Hilton
                                                                        Da Nang
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.bayresorthoian.com"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Bay
                                                                        Resort
                                                                        Hoi An
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.sandybeachdanang.com"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Sandy
                                                                        Beach
                                                                        Non-Nuac
                                                                        Resort
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                            <a
                                                                    target="_blank"
                                                                    href="https://grandsunriseboutiquehotel.com/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                    Grand Sunrise
                                                                Boutique
                                                                    </u>
                                                                </a>
                                                                
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.fourseasons.com/hoian/accommodations/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Hoi An
                                                                        Four
                                                                        Season
                                                                        Villa
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://hanamihotel.com/en/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Hanami
                                                                        Hotel
                                                                        Danang
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                    <td className="px-6 py-4 text-left">
                                                        <strong>
                                                            Phu Quoc
                                                        </strong>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://wyndhamgrand-phuquoc.com/en/home/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Wyndham
                                                                        Grand
                                                                        Phu Quoc
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://vinpearl.com/en/hotels/vinholidays-fiesta-phu-quoc"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Vinholidays
                                                                        Fiesta
                                                                        Phu Quoc
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.phuquococeanpearlhotel.com/en/trang-chu/"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Phu Quoc
                                                                        Ocean
                                                                        Pearl
                                                                        Hotel
                                                                    </u>
                                                                </a>
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.melia.com/en/hotels/vietnam/phu-quoc/sol-phu-quoc"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        Sol by
                                                                        Melia
                                                                        Phu Quoc
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <div className="grid grid-cols-1 divide-y">
                                                            <div className="p-3">
                                                                Hanz Sunset Mini
                                                                Hotel Grand
                                                                World Phu Quoc
                                                            </div>
                                                            <div className="p-3">
                                                                <a
                                                                    target="_blank"
                                                                    href="https://www.thegardenhousephuquoc.com"
                                                                    className="color-blue"
                                                                >
                                                                    <u>
                                                                        The
                                                                        Garden
                                                                        House
                                                                        Phu Quoc
                                                                        Resort
                                                                    </u>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Transportation in Vietnam
                                    </Heading>
                                    <p className="lead">
                                        If you are considering how to travel in
                                        Vietnam, you need not worry as you get
                                        various means of transportation to roam
                                        around in Vietnam. You get motorbikes,
                                        cars, buses, trains, ferries, rickshaws,
                                        etc in Vietnam. But if you want a
                                        hassle-free trip, Dimaak Tours offers
                                        its means for airport pickups and
                                        sightseeing transfers.
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>Motorbikes:</strong> In
                                            Vietnam, motorbikes are an efficient
                                            way to roam around the city with
                                            your loved ones. They also give you
                                            the chance to explore each corner
                                            and gain insight into the city. The
                                            best way to get to know the
                                            different regions is by taking a
                                            motorbike ride.
                                        </li>
                                        <li>
                                            <strong>Cars: </strong> You can also
                                            rent cars to travel long distances.
                                            Grab is a vehicle booking app that
                                            usually offers good car options and
                                            premium vehicles. So you can sit
                                            back and enjoy your honeymoon ride.
                                        </li>
                                        <li>
                                            <strong>Buses: </strong> Buses are
                                            readily available in Vietnam. They
                                            are a budget-friendly option for
                                            roaming between towns. Open tour
                                            buses are also available, giving you
                                            the city's nicest view.
                                        </li>
                                        <li>
                                            <strong>Rickshaws: </strong> These
                                            are also known as Cyclos. They are
                                            found in Ho Chi Minh City, and in
                                            comparison to other means of
                                            transport, they are not very
                                            frequent.
                                        </li>
                                        <li>
                                            <strong>Trains: </strong> Taking
                                            trains for intercity rides between
                                            Hanoi and Ho Chi Minh City is also a
                                            good option for enjoying the scenic
                                            view of Vietnam.
                                        </li>
                                        <li>
                                            <strong>Ferries: </strong> It
                                            connects Vietnam with its islands,
                                            such as Phu Quoc and Ha Long Bay.
                                            They also travel through waterways,
                                            crossing the Mekong Delta and
                                            offering a beautiful riverside view.
                                        </li>
                                        <li>
                                            <strong>Cruises: </strong> It is the
                                            most luxurious way to get around
                                            Halong Bay, viewing towering
                                            limestone formations and its hidden
                                            coves.
                                        </li>
                                        <li>
                                            <strong>
                                                Helicopters and Airplanes:{" "}
                                            </strong>{" "}
                                            What could be more unique than
                                            taking your better half on a
                                            helicopter ride? To make your
                                            Vietnam honeymoon tour more special,
                                            you can also take a helicopter ride
                                            to get an Aerial view of the
                                            country.
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Souvenir Shopping in Vietnam
                                    </Heading>
                                    <p className="lead">
                                        Are you thinking about what is famous in
                                        Vietnam to buy? Don't worry; the list
                                        goes on. There are many things to buy in
                                        Vietnam so you can buy different kinds
                                        of souvenirs for different people.
                                    </p>
                                    <div className="ml-5">
                                        <Heading as="h4">
                                            1. Water Puppet:
                                        </Heading>
                                        <p className="lead">
                                            Vietnam is also popular for its
                                            water puppetry show, in which each
                                            puppet represents a character from
                                            Vietnamese legends and folktales. It
                                            is a traditional Vietnamese art
                                            form. So, taking water puppets from
                                            Vietnam can become a culturally rich
                                            souvenir that will be loved.
                                        </p>
                                        <Heading as="h4">
                                            2. Bamboo Product:
                                        </Heading>
                                        <p className="lead">
                                            Vietnam is the largest producer of
                                            bamboo, and its products are very
                                            popular. The Non-La (Conical Hat) is
                                            a part of traditional Vietnamese
                                            attire that complements rural life.
                                            Taking it back to your homeland will
                                            help you preserve memories of your
                                            time in this beautiful country.
                                        </p>

                                        <p className="lead">
                                            You also get home decor (frames,
                                            vases, and lamps) and kitchenware
                                            (bamboo cutting boards, spoons,
                                            forks, straws, bowls, plates). Also,
                                            the hand fans are great to present
                                            as a souvenir and are made of
                                            bamboo.
                                        </p>
                                        <Heading as="h4">
                                            3. Food Souvenir:
                                        </Heading>
                                        <p className="lead">
                                            Vietnam is the major producer of
                                            coffee, and it is very strong.
                                            Trying Ca Phe Sua Da (iced- coffee)
                                            and taking it back home will be a
                                            good souvenir from Vietnam. Sipping
                                            it home will make you nostalgic and
                                            bring you back to Vietnam.
                                            Similarly, there are a few other
                                            food souvenirs that you can take,
                                            like-
                                        </p>
                                        <ul>
                                            <li>
                                                Peanut and rice paper brittle
                                            </li>
                                            <li>Coconut candy</li>
                                            <li>Pia cake</li>
                                            <li>Mung bean cake</li>
                                            <li>Rice paper</li>
                                            <li>Marou chocolate</li>
                                            <li>Vietnamese fish sauce</li>
                                            <li>Dry Fruits</li>
                                        </ul>
                                        <Heading as="h4">
                                            4. Vietnamese Paintings:
                                        </Heading>
                                        <p className="lead">
                                            Vietnamese Paintings reflect its
                                            rich art. There are many varieties
                                            of paintings, and you can find
                                            exquisite and unique Vietnamese and
                                            Ho Chi Minh City souvenirs.
                                        </p>
                                        <ul>
                                            <li>
                                                Dong Ho folk woodcut paintings
                                            </li>
                                            <li>Smoked bamboo paintings</li>
                                            <li>Silk paintings</li>
                                            <li>Rice paintings</li>
                                            <li>Embroidery paintings</li>
                                        </ul>
                                        <Heading as="h4">
                                            5. Brocade Bags:
                                        </Heading>
                                        <p className="lead">
                                            These timeless designs of bags are
                                            made of Hemp by the Hmong people in
                                            Vietnam.
                                        </p>
                                        <p className="lead">
                                            It is a good present to give to your
                                            loved ones.
                                        </p>
                                        <Heading as="h4">
                                            6. Vietnamese Silk:
                                        </Heading>
                                        <p className="lead">
                                            It is one of the finest silks in the
                                            world. You can get Ao Ba Ba, the
                                            traditional attire of Vietnamese
                                            people consisting of a top and
                                            pants.
                                        </p>
                                        <p className="lead">
                                            Ao Dai is the national dress of
                                            Vietnam. It is also one of the
                                            souvenirs that you can get from
                                            Vietnam.
                                        </p>
                                        <p className="lead">
                                            Also, the checkered scarf is very
                                            popular in Vietnam. The people of
                                            South Vietnam historically used it
                                            as neck warmers, hat scarves, and
                                            towels.
                                        </p>
                                        <Heading as="h4">
                                            7. Vietnamese Lanterns:
                                        </Heading>
                                        <p className="lead">
                                            It is one of the most popular Hoi An
                                            souvenirs. You can buy lantern
                                            lights of different sizes, patterns,
                                            shapes, and colors. They are
                                            traditionally made of bamboo frames
                                            with silk wrapped around them,
                                            giving them a traditional and shiny
                                            look. The intricate design on the
                                            silk represents Vietnamese folklore,
                                            symbols, etc.
                                        </p>
                                        <Heading as="h4">
                                            8. Lacquerware:
                                        </Heading>
                                        <p className="lead">
                                            It is known for its vibrant colors
                                            and craftsmanship. It is the
                                            traditional form commonly applied to
                                            furniture, dishes, bowls, vases, and
                                            paintings, and completing a
                                            masterpiece can take up to four
                                            months. It is renowned for its
                                            durability, which lasts long.
                                        </p>
                                    </div>

                                    <p className="lead">
                                        {" "}
                                        <strong>
                                        Additional Tips for souvenir shopping:</strong>
                                    </p>
                                    <ul>
                                        <li>Keep cash</li>
                                        <li>Buy from a renowned seller</li>

                                        <li>
                                            Be gentle and modest while
                                            bargaining
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Vietnamese cuisine that Indians must try
                                    </Heading>
                                    <p className="lead">
                                        Vietnamese cuisine is popular for its
                                        fresh flavors. You can find a balanced
                                        flavor of sweet, spicy, sour and salty.
                                        You get dipping sauces with all its
                                        dishes. Below mentioned are some of the
                                        must-try vegetarian and non-vegetarian
                                        dishes in Vietnam for honeymoon couples-
                                    </p>
                                    <Heading as="h4">
                                        Vegetarian options in Vietnam
                                    </Heading>
                                    <ul>
                                        <li>
                                            <strong>Pho chay</strong> is a very
                                            popular Vietnamese noodle soup. It
                                            is made of Rice noodles, vegetables,
                                            tofu, and fresh herbs.
                                        </li>
                                        <li>
                                            <strong>Goi cuon chay</strong> is a
                                            spring roll made from rice paper
                                            wrappers, filled with vermicelli
                                            noodles, herbs, lettuce, cucumber,
                                            and other vegetables, and served
                                            with a peanut dipping sauce.
                                        </li>
                                        <li>
                                            <strong>Com chay</strong> is a
                                            stir-fried vegetable dish with fried
                                            tofu, lemongrass mushrooms, and
                                            pickles. You can choose your own
                                            vegetables.
                                        </li>
                                        <li>
                                            <strong>Banh mi chay: </strong> It
                                            is a sandwich filled with a variety
                                            of vegetarian options like pate made
                                            from tofu or mushrooms, pickled
                                            vegetables, herbs, and chili sauce,
                                            all served on a crispy French
                                            baguette.
                                        </li>
                                        <li>
                                            <strong>Xoi chay</strong> is a
                                            steamed sticky rice dish with
                                            coconut milk. It can be served plain
                                            or with various toppings, such as
                                            fried shallots, mung beans, or fried
                                            tofu.
                                        </li>
                                    </ul>
                                    <Heading as="h4">
                                        Non-vegetarian options in Vietnam for
                                        Indian honeymoon couples
                                    </Heading>
                                    <ul>
                                        <li>
                                            <strong>Bun Bo Hue</strong> is a
                                            noodle soup. The broth is simmered
                                            for hours with beef bones,
                                            lemongrass, and other spices,
                                            resulting in a deep, complex flavor.
                                            The soup is typically served with
                                            rice noodles, thin slices of beef,
                                            and a variety of herbs and
                                            vegetables.
                                        </li>
                                        <li>
                                            <strong>Com Tam </strong> is a
                                            breakfast dish in Vietnam, but you
                                            can have it anytime. It is served
                                            with grilled pork or chicken, a
                                            fried egg, pickled vegetables, and a
                                            dipping sauce. You can add any
                                            variety of toppings, such as
                                            shredded pork skin, roasted peanuts,
                                            and chili sauce.
                                        </li>
                                        <li>
                                            <strong>
                                                Bún Chả (Hanoi Bun Cha):
                                            </strong>{" "}
                                            grilled pork served with rice
                                            noodles, fresh herbs, and a dipping
                                            sauce. It is grilled over charcoal
                                            and has a smoky and savory flavor.
                                            Bun Cha is often served with a side
                                            of fried spring rolls.
                                        </li>
                                        <li>
                                            <strong>Banh Mi </strong>{" "}
                                            (Vietnamese Baguette): popular
                                            street food item in Vietnam.
                                            Consists of a crusty baguette.
                                            Include pork, pate, pickled
                                            vegetables, and herbs. Banh Mi is a
                                            delicious and affordable way to try
                                            a variety of Vietnamese flavors.
                                        </li>
                                        <li>
                                            <strong>
                                                Mi Quang (Yellow Noodle Soup):
                                            </strong>{" "}
                                            Noodle soup is a specialty of
                                            central Vietnam and is made with
                                            turmeric-dyed rice noodles, pork,
                                            shrimp, and various vegetables. The
                                            broth is flavorful and slightly
                                            sweet, and the noodles have a chewy
                                            texture. Mi Quang is often served
                                            with a side of herbs and lime
                                            wedges.
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h2">
                                    Unique Things to Do in Vietnam
                                    </Heading>
                                    <p className="lead">
                                    Every country has unique things to offer, and Vietnam does too. It offers experiences that are beyond the normal tourist attractions. Add some of the best things to your to-do list when you visit Vietnam -
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>
                                                Hoi An Lantern Festival:
                                            </strong>{" "}
                                            It is a lantern-lighting festival in
                                            which the entire Hoi An Ancient Town
                                            is decorated with lantern lights of
                                            different sizes, patterns, shapes,
                                            and colors, giving the capital city
                                            a vibrant, magical look. This
                                            festival falls on the 14th day of
                                            every lunar month, coinciding with
                                            the full moon. [lantern lights are
                                            also floated on the Thu Bon River,
                                            giving the entire city a mystic
                                            look].
                                        </li>
                                        <li>
                                            <strong>
                                            Traditional Ao Dai Costume Photoshoot:
                                            </strong>{" "}
                                            Tell me, who doesn’t keep a memory of the visited place? The best way to re-live those memories is through a photograph. One of the best things a honeymoon couple can do in Vietnam is to wear a Traditional Ao Dai costume and photoshoot. So, live the Vietnamese culture through its traditional Ao Dai Costume.

                                        </li>
                                        <li>
                                            <strong>
                                            Water Puppet Show Hanoi:
                                            </strong>{" "}
                                            It portrays the traditional Vietnamese Art Form. In the water puppetry show, each puppet represents a character from Vietnamese legends and folktales. The show has a captivating effect, and you will be lost in the mesmerizing Vietnamese art.

                                        </li>
                                        <li>
                                            <strong>
                                            Spelunking and Potholing:
                                            </strong>{" "}
                                            Vietnam is very popular for its large caves. It is a paradise for spelunking enthusiasts. Spelunking is the other name for caving. Phong Nha-Ke Bang National Park, situated in Quang Binh Province, is a UNESCO World Heritage Site that has the world’s most beautiful caves.
                                            

                                        </li>
                                        <p className="lead">
                                        [Note: If you are physically fit, you should go for Spelunking and Patholing. And wear proper equipment, including a helmet, headlamp, gloves, and sturdy shoes].
                                        </p>
                                        <li>
                                            <strong>
                                            Crawl through Chu Chi Tunnel:
                                            </strong>{" "}
                                            It is one of the best things to do for a honeymoon couple in Vietnam. You can crawl through the labyrinth of Chu Chi Tunnel and experience Vietnam's wartime history. These tunnels were used as bunkers, hiding spots, and communication routes during wartime.
                                            

                                        </li>
                                        
                                    </ul>
                                    <p className="lead">
                                    So, if you are in Vietnam for your honeymoon, try these unique things to do for a chilling and calming experience
                                    </p>
                                </div>
                                <div className="flex flex-col gap-1">
                                <Heading as="h3">
                                Vietnam City Nightlife Guide
                                    </Heading>
                                    <p className="lead">
                                    Vietnam offers a plethora of nightlife experiences. You will find a variety of activities that match your tastes. To experience the best nightlife in Vietnam, check out some of the ideas given below,
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>
                                            Food and Shopping Markets:
                                            </strong>{" "}
                                            Hanoi Old Quarter has 30+ streets with all kinds of shops to meet your needs. Dong Xuan Market is a wholesale market where you can get everything from clothes and food to household items.
                                        </li>
                                        <p className="lead">
                                        You must visit Ho Chi Minh Bui Vien Walking Street. This street is very popular in the city as it is lined with many bars, coffee shops, restaurants, and street food stalls with lights, loud music, and fragrant aromas of Vietnamese cuisine.</p>
                                        <li>
                                            <strong>
                                            Live Entertainment:
                                            </strong>{" "}
                                            Experience Vietnamese culture and tradition through its rich performances. Traditional shows include water puppetry shows, Ca Tru Singing, Xam shows, and Don Ca Tai Tu performances.

                                        </li>
                                        <li>
                                            <strong>
                                            Night Bars and Clubs:
                                            </strong>{" "}
                                            If you are looking for thriving nightlife scenes, go to Hanoi and Ho Chi Minh City. You will get nightclubs, rooftop bars and pubs and can enjoy it with live music or loud music. Also, Nha Trang and Phu Quoc are filled with beach bars and clubs.

                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                <Heading as="h3">
                                Conclusion
                                    </Heading>
                                    <p className="lead">
                                    From Halong Bay's beauty to Hanoi's vibrant streets and the serene landscapes of Hoi An, every destination is imbued with romance and charm. With handcrafted itineraries, luxurious accommodations, and personalized experiences, we strive to make your Vietnam honeymoon Tour a seamless blend of relaxation, adventure, and romance.  Let us be your guide as you begin this new chapter together, where every moment is filled with love and wonder.<a href="https://wa.me/919600099777?text=Hi,%20I%20am%20Seeking%20Details%20on%20Tour%20Packages." target="_blank"><i><u>Book your dream honeymoon</u></i></a>  with Dimaak Tours today, and let the magic of Vietnam ignite your love story.
                                    </p>
                                    
                                </div>
                                
                                
                            </div>
                        </div>
                        {showSecondContainer && (
                            <div className="traffic-footer flex-wrap flex items-center justify-evenly gap-3 md:gap-5 pt-4">
                                <div>
                                    <a
                                        target="_blank"
                                        href="https://wa.me/919600099777?text=Hi,%20I%20am%20Interested%20in%20Vietnam%20Honeymoon%20Packages."
                                    >
                                        <Button
                                            className="flex items-center gap-3"
                                            variant="green"
                                            onClick={handleViewLess}
                                        >
                                            <Image
                                                src={Buttonwhatsapp}
                                                alt="whatsappimage"
                                            />
                                            <span>Get Quote</span>
                                        </Button>
                                    </a>
                                </div>
                                <div
                                    className="flex items-center gap-3 cursor-pointer"
                                    onClick={handleViewLess}
                                >
                                    <span className="text-link">View Less</span>
                                    <Image src={RightIcon} alt="right icon" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Tariff;
